import { render, staticRenderFns } from "./av-selectable.vue?vue&type=template&id=7fbd5484"
import script from "./av-selectable.vue?vue&type=script&lang=js"
export * from "./av-selectable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports